module.exports = __webpack_public_path__ + "assets/images/glasses-01.6688bb580c9ef42cad10f652e2cf273d.svg";